import { Component, Input } from "@angular/core";
import { UserMe } from "../../interfaces/user-me.interface";
import { CommonModule } from "@angular/common";
import { Observable } from "rxjs";

@Component({
    imports: [CommonModule],
    selector: "pl-recertification-date",
    templateUrl: "./recertification-date.component.html",
    styleUrls: ["./recertification-date.component.scss"]
})
export class RecertificationDateComponent {
  @Input() info!: Observable<UserMe | null | undefined>;
}
